<template>
  <div class="bq-intro">
    <section-title title="基地介绍" />
    <div class="base-intro">
      <div class="base-intro-title">
        <!-- 扁鹊孵化器：让健康触手可得，依托阿里健康下属浙江扁鹊 -->
      </div>
      <div class="base-intro-content">
        <div
          class="base-intro-content-item"
          v-for="item in contentData"
          :key="item.id"
        >
          <img class="base-intro-content-item-icon" :src="item.iconUrl" />
          <div class="base-intro-content-item-desc">{{ item.desc }}</div>
        </div>
      </div>
      <div class="base-intro-content-extra">
        五链合一，打造专业智慧医疗生态孵化平台，持续服务医疗信息化、在线化、智能化、精准化。
      </div>
    </div>

    <section-title title="入驻条件" />
    <div class="condition">
      <div
        class="condition-content"
        v-for="item in conditionData"
        :key="item.id"
      >
        <img :src="item.imgUrl" />
        <div class="condition-content-extra">
          <p class="condition-content-extra-title">{{ item.title }}</p>
          <p class="condition-content-extra-subtitle">{{ item.subtitle }}</p>
        </div>
      </div>
    </div>

    <section-title title="入驻福利" />
    <section class="bq-advantage">
      <div
        class="bq-advantage-item"
        v-for="item in advantages"
        :key="item.advTitles"
      >
        <img
          :src="item.iconUrl"
          alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          class="bq-advantage-icon"
        />
        <div>{{ item.advTitles }}</div>
        <p>{{ item.advDesc }}</p>
      </div>
    </section>

    <div class="bq-info-bg"></div>
    <div class="bq-qrcode"></div>
    <div class="bq-qrcode-desc">扫一扫关注扁鹊孵化器</div>
  </div>
</template>

<script>
import SectionTitle from '@/components/website_v3/SectionTitle';

export default {
  name: 'Intro',

  components: {
    SectionTitle,
  },

  data() {
    return {
      contentData: [
        {
          id: '1',
          iconUrl:
            'https://img.alicdn.com/tfs/TB1MXgYCBr0gK0jSZFnXXbRRXXa-84-84.png',
          desc: '政',
        },
        {
          id: '2',
          iconUrl:
            'https://img.alicdn.com/tfs/TB15MINCuT2gK0jSZFvXXXnFXXa-62-84.png',
          desc: '产',
        },
        {
          id: '3',
          iconUrl:
            'https://img.alicdn.com/tfs/TB13vZQCy_1gK0jSZFqXXcpaXXa-84-84.png',
          desc: '研',
        },
        {
          id: '4',
          iconUrl:
            'https://img.alicdn.com/tfs/TB1Uw7QCAL0gK0jSZFxXXXWHVXa-84-84.png',
          desc: '金',
        },
        {
          id: '5',
          iconUrl:
            'https://img.alicdn.com/tfs/TB1ZJ3YCBr0gK0jSZFnXXbRRXXa-84-84.png',
          desc: '才',
        },
      ],
      conditionData: [
        {
          id: '1',
          imgUrl:
            'https://img.alicdn.com/tfs/TB10jARCEH1gK0jSZSyXXXtlpXa-580-558.png',
          title: '项目领域',
          subtitle: '大健康',
        },
        {
          id: '2',
          imgUrl:
            'https://img.alicdn.com/tfs/TB1vtUWCrj1gK0jSZFOXXc7GpXa-580-558.png',
          title: '融资轮次',
          subtitle: '种子以上，考虑有过一轮融资',
        },
      ],
      advantages: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB19lw1CAT2gK0jSZPcXXcKkpXa-82-68.png',
          advTitles: '政策咨询',
          advDesc:
            '集成政府各部门鼓励双创及产业发展的相关政策，掌握最全面、及时的政策信息',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1qjGcF4D1gK0jSZFyXXciOVXa-82-64.png',
          advTitles: '产业联动',
          advDesc:
            '与扁鹊一起形成产业链的上下游互通，共建高效合作体系，共同为用户提供服务',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1Lx7YCrr1gK0jSZFDXXb9yVXa-68-76.png',
          advTitles: '科研链接',
          advDesc: '链接各大科研机构，引入新技术新项目，推动项目合作',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1_Ik2CxD1gK0jSZFyXXciOVXa-82-70.png',
          advTitles: '融资速递',
          advDesc: '集合多家大健康领域产业资本、创投机构为优质企业提供融资支撑',
        },
      ],
    };
  },

  // created() {
  // },

  // mounted() {
  //   this.$route.query.locat && this.locatTo(this.$route.query.locat);
  // },

  // methods: {
  // },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
